import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getPublicSettings } from "../core/services/catalogService";
import Footer from "../shared/Footer";
import Header from "../shared/Header";
import Toast from "../shared/Toast";
import storeLogo from "../assets/images/logo.png";

export default function Layout() {
  const [settings, setSettings] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const openLogin = () => navigate("/login", { state: { from: location.pathname } });

  useEffect(() => {
    getPublicSettings().then((data) => setSettings(data.settings || data)).catch(() => { });
  }, []);

  return (
    <>
      <Header onLogin={openLogin} />
      {settings?.features?.maintenanceMode ? (
        <main className="maintenance page-shell">
          <img src={storeLogo} alt="Sugam Store" />
          <p className="eyebrow">We'll be right back</p>
          <h1>Our shelves are getting a little care.</h1>
          <p>Please check back soon.</p>
        </main>
      ) : <Outlet context={{ settings, openLogin }} />}
      <Footer settings={settings} />
      <Toast />
    </>
  );
}
